import { render, staticRenderFns } from "./ArtCardRow.vue?vue&type=template&id=1458b74d&scoped=true&"
import script from "./ArtCardRow.vue?vue&type=script&lang=js&"
export * from "./ArtCardRow.vue?vue&type=script&lang=js&"
import style0 from "./ArtCardRow.vue?vue&type=style&index=0&id=1458b74d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1458b74d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
